import React from "react";
import Modal from "react-modal";


const PopUpModal = ({ modalIsOpen, setModalIsOpen, comp, children, handleSave }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#f0f0f0", // Example background color
      padding: "2rem",
      borderRadius: "1rem",
      width: "40%",
      textAlign: "center",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)", // Example overlay background color
      zIndex:1000
      
    },
  };

  return (
    <div>
      {/* <button onClick={() => setModalIsOpen(true)}>Open Modal</button> */}
      <Modal
        style={customStyles}
        isOpen={modalIsOpen}
        // onRequestClose={() => handleSave(false)}
      >
        {children}
     
      </Modal>
    </div>
  );
};

export default React.memo(PopUpModal);
